<template>
    <div>
        <b-card-group grid>
            <!-- <b-card no-body v-for="item,idx in items" :style="{'max-width': '200px', 'min-width': '200px', 'margin': '5px'}">
                <Grid :viewdata="item" />
            </b-card> -->

            <b-card no-body v-for="item,idx in items" :style="{'max-width': '150px', 'min-width': '150px', 'margin': '5px'}" v-bind:key="idx">
                <Six :viewdata="item" />
            </b-card>
        </b-card-group>
            
    </div>
</template>

<script>
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";

    import * as d3 from 'd3';
    import moment from "moment"
    import global_vars from "@/utilities/global_vars"
    import Backer from "@/components/globals/Backer"
    import Requestor from "@/utilities/Requestor"
    import Grid from "@/components/importables/Grid"
    import Six from "@/components/importables/Six"

    export default {
        name: "AdminToolsStorePickups",
        components: {Backer, flatPickr, Grid, Six},
        data: function() {
            return {
                packet: {},
                items: [],
            }
        },
        methods: {
            gen_data: function(idx, n){
                let width = 150;
                let height = 150;

                let nboxes = n*n;
                let pad_x = width/n;
                let pad_y = height/n;
                let x = 0;
                let y = 0-pad_y;
                let wsum = 0;

                let data = d3.range(nboxes).map(function(d){
                    x = pad_x * (d % n);
                    if (d % n == 0){
                        y += pad_y;
                    }

                    let weight = Math.random();
                    let fill = ""
                    if (weight < 0.5){
                        fill = "white"
                    }
                    else {
                        fill = "#aae0ffeb"
                        wsum += 1;
                    }

                    return {
                        x: x,
                        y: y,
                        fill: fill,
                        idx: idx,
                        id: d,
                        w: pad_x,
                        h: pad_y,
                    }
                });

                return {
                    idx: idx,
                    data: data,
                    width: width, 
                    height: height,
                    wsum: wsum
                }

            },
            get_poly_color: function(){
                let i = Math.random();
                if (i < 0.3){
                    return 'gray'
                }
                else {
                    return 'black'
                }
            },
            gen_data2: function(idx){
                var width = 150;
                var height = 150;

                let n = width/8;
                let m = height/8;

                let points = [
                    {
                        color: this.get_poly_color(),
                        poly: this.get_poly([[n*4, m*0], [n*5, m*1], [n*5, m*2], [n*4, m*3], [n*3, m*2], [n*3, m*1], [n*4, m*0]])

                    },
                    {
                        color: this.get_poly_color(),
                        poly: this.get_poly([[n*3, m*2], [n*4, m*3], [n*4, m*4], [n*3, m*5], [n*2, m*4], [n*2, m*3], [n*3, m*2]])

                    },
                    {
                        color: this.get_poly_color(),
                        poly: this.get_poly([[n*5, m*2], [n*6, m*3], [n*6, m*4], [n*5, m*5], [n*4, m*4], [n*4, m*3], [n*5, m*2]])
                    },
                    {
                        color: this.get_poly_color(),
                        poly: this.get_poly([[n*2, m*4], [n*3, m*5], [n*3, m*6], [n*2, m*7], [n*1, m*6], [n*1, m*5], [n*2, m*4]])

                    },
                    {
                        color: this.get_poly_color(),
                        poly: this.get_poly([[n*4, m*4], [n*5, m*5], [n*5, m*6], [n*4, m*7], [n*3, m*6], [n*3, m*5], [n*4, m*4]])

                    },
                    {
                        color: this.get_poly_color(),
                        poly: this.get_poly([[n*6, m*4], [n*7, m*5], [n*7, m*6], [n*6, m*7], [n*5, m*6], [n*5, m*5], [n*6, m*4]])

                    }
                ]

                return {
                    width: width,
                    height: height,
                    n: n,
                    m: m,
                    points: points,
                    idx: idx
                }

            },
            get_poly: function(poly){
                let output = [];
                for (var i = 0; i<poly.length; i++){
                    output.push(poly[i][0]+", "+poly[i][1])
                }
                output = output.join(" ")
                return output
            }
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            //this.fetch_init()
            for (var i =0; i<100; i++){
                let item = this.gen_data2(i);

                let wsum = item.points.filter(function(d){return d.color == 'black'}).length;
                item.wsum = wsum;
                this.items.push(item)
            }

            this.items = this.items.sort((a, b) =>  b.wsum - a.wsum)
            
            
        }
    }
</script>

<style scoped>
    .non-header {
        font-weight: normal;
        font-size: 12px;
    }

    .ipt_tdhr {
        font-weight: normal;
    }
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/AdminToolsStorePickups.vue